import { connect } from 'react-redux'
import {
  addNewCarData,
  clearData,
  createCarfile,
  getAllAccessories,
  getBids,
  getCarBrands,
  getCarModels,
  getCarTypes,
  getEditions,
  getLicensePlate,
  getNap,
  updateCarfile,
  deleteCarAssets,
  sortCarAssets,
  rotateImages,
} from 'redux/actions/data'
import { getForms } from 'redux/actions/forms'
import CarValuationView from '../views/valuation/car-valuation-view'

const mapStateToProps = ({ data, forms }) => ({
  carBrands: data.carBrands,
  carModels: data.carModels,
  carTypes: data.carTypes,
  edition: data.edition,
  editions: data.editions,
  licensePlate: data.licensePlate,
  newCar: data.newCar,
  nap: data.nap,
  forms: forms.valuation,
})

const mapDispatchToProps = {
  addNewCarData,
  clearData,
  createCarfile,
  getAllAccessories,
  getCarBrands,
  getCarModels,
  getCarTypes,
  getBids,
  getEditions,
  getForms,
  getLicensePlate,
  getNap,
  updateCarfile,
  deleteCarAssets,
  sortCarAssets,
  rotateImages,
}

export default connect(mapStateToProps, mapDispatchToProps)(CarValuationView)
